import React from 'react';
import {
  CourseAnalyticsLearnerDetails,
  CourseLearnersAnalyticsItem,
} from '../../../../../data/models/Gradebook/CourseAnalyticsModels';
import {analyticsText} from '../../../analyticsText';
import './styles.css';
import AnalyticsEmptyState from '../../../../../uiToolkit/Analytics/AnalyticsEmptyState';
import LearnersAnalyticsTable from '../components/LearnersAnalyticsTable';
import LearnerAnalyticsDetails from '../components/LearnerAnalyticsDetails';
import AnalyticsNavigationTabs from '../../../../../uiToolkit/Analytics/AnalyticsNavigationTabs';
import {courseLevelAnalyticsTabs} from '../../conf';

interface Props {
  courseAnalyticsLearners: CourseLearnersAnalyticsItem[];
  onBack: () => void;
  onSelectLearner: (learnerId: string) => void;
  selectedLearnerGradebook?: CourseAnalyticsLearnerDetails;
  onCloseLearnerDetails: () => void;
  onOpenLearningJourney: (learnerId: string, lessonId: string) => void;
  isGradable: boolean;
  passingScore?: number;
  search: string;
  onExport: () => void;
  setSeach: (search: string) => void;
  organizationId: string;
  courseId: string;
  onChangeSort: (field: string, asc: boolean) => void;
  sortBy: string;
  sortAsc: boolean;
  onChangeGrade: (
    learnerId: string,
    lessonId: string,
    newGrade: number,
  ) => Promise<boolean>;
}

const CourseAnalyticsLearnersUI = React.memo(
  ({
    courseAnalyticsLearners,
    onSelectLearner,
    selectedLearnerGradebook,
    onCloseLearnerDetails,
    onOpenLearningJourney,
    isGradable,
    passingScore,
    search,
    setSeach,
    onExport,
    organizationId,
    courseId,
    onChangeSort,
    sortBy,
    sortAsc,
    onChangeGrade,
  }: Props) => {
    const getLearners = () => {
      if (search) {
        return courseAnalyticsLearners.filter(x =>
          x.name.toLowerCase().includes(search.toLowerCase()),
        );
      } else {
        return courseAnalyticsLearners;
      }
    };

    return (
      <div>
        <AnalyticsNavigationTabs
          onExport={onExport}
          search={search}
          setSearch={setSeach}
          tabs={courseLevelAnalyticsTabs(organizationId, courseId)}
        />

        <div>
          {isGradable ? (
            <div className="PassingScoreContainer">
              <span className="icon-icon_score"></span>
              <span className="InfoText">{analyticsText.passingScore}</span>
              <span className="ScoreText">{passingScore}</span>
            </div>
          ) : (
            <div />
          )}
          {!courseAnalyticsLearners.length ? (
            <AnalyticsEmptyState />
          ) : (
            <div className="TableAndDetails">
              <LearnersAnalyticsTable
                learners={getLearners()}
                onSelectLearner={onSelectLearner}
                passingScore={passingScore || 50}
                isGradable={isGradable}
                onChangeSort={onChangeSort}
                sortField={sortBy}
                asc={sortAsc}
              />
              {selectedLearnerGradebook && (
                <LearnerAnalyticsDetails
                  analytics={selectedLearnerGradebook}
                  onClose={onCloseLearnerDetails}
                  onOpenLearningJourney={onOpenLearningJourney}
                  isGradable={isGradable}
                  onChangeGrade={onChangeGrade}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default CourseAnalyticsLearnersUI;
